import { pushEventData } from "./utils";

const initDataLayerEvents = () => {
    document.addEventListener("dataLayer.interconnection", (event) => {
        const eventData = {
            event: "interconnection",
            interconnection: event.detail.interconnection || false,
            mailingUserId: event.detail.mailingUserId || ""
        };
        pushEventData(eventData);
    });
};

module.exports = {
    initDataLayerEvents,
};
